<div class="content">
  <div class="title">Übersicht Fremdeinschätzungen</div>
  @if ((assessments$ | async); as assessments) {
    <div class="card-list" [@staggerElementsAnimation]="assessments">
      @for (assessment of assessments; track assessment) {
        <div class="card" [ngClass]="assessment.status">
          <div class="diameter">
            <svg viewBox="0 0 32 32">
              <circle r="16" cx="16" cy="16" [style.stroke-dasharray]="getDiameter(assessment)" />
            </svg>
            <div class="diameter-inner">
              <div class="assessment-progress">{{assessment.answerSetsCount}} / {{assessment.participantsCount}}</div>
            </div>
          </div>
          <div class="assessment-name">{{assessment.name}}</div>
          @switch (assessment.status) {
            @case ('active') {
              <div class="assessment-duration">{{getDurationString(assessment.remainingDays)}}</div>
              <button mat-icon-button (click)="addParticipantTo(assessment)" matTooltip="Weiteren Teilnehmer hinzufügen">
                <i-feather name="plus-circle"></i-feather>
              </button>
            }
            @case ('finished') {
              <div class="assessment-status">Beendet</div>
            }
            @case ('cancelled') {
              <div class="assessment-status">Abgebrochen</div>
            }
          }
          @if (showCancelButton(assessment)) {
            <button mat-stroked-button color="warn" (click)="openCancelDialog(assessment)">Beenden</button>
          }
        </div>
      }
    </div>
  }
  <div class="actions">
    <button mat-flat-button color="accent" (click)="openAssessmentDialog()">Neue Fremdeinschätzung starten</button>
  </div>
</div>
